export default "__VITE_PUBLIC_ASSET__58b44f81__"